import { Card, Button } from "@aws-amplify/ui-react"

const ExerciseCard = ({ exercise, onClick, isSelected,
    onUp,
    onDown,
    isFirst,
    isLast
}) => {
    return (
        <Card
            onClick={onClick}
            className={!isSelected ? `mx-2 my-3 text-align-start exercise-card shadow-4 ` : `mx-2 my-3 text-align-start exercise-card selected-card shadow-4`}
        >
            <div className="d-flex justify-content-between">
                <h5>{exercise?.name}</h5>

                <div className="d-flex align-items-center">
                    {exercise?.favorite &&
                        <span className="material-symbols-outlined" style={{ fontVariationSettings: "'FILL' 1" }}>
                            favorite
                        </span>
                    }
                    {!isLast &&
                        <Button variant="link"
                            onClick={onDown} style={{ aspectRatio: '1f' }}
                            className={`border-0 p-0 me-1  d-flex align-items-center justify-content-center custom-focus-button`}>
                            <span
                                className="material-symbols-outlined m-1">
                                arrow_drop_down
                            </span>

                        </Button>
                    }

                    {!isFirst &&
                        <Button variant="link"
                            onClick={onUp}
                            style={{ aspectRatio: '1f' }}
                            className={`border-0 p-0  d-flex align-items-center justify-content-center custom-focus-button`}>
                            <span
                                className="material-symbols-outlined m-1">
                                arrow_drop_up
                            </span>
                        </Button>
                    }


                </div>


            </div>
            <p className="lines-4">
                {exercise?.description}
            </p>
        </Card>
    )
}

export default ExerciseCard